module.exports = __webpack_public_path__ + "img/step5.0803940b.png";